module.exports = __webpack_public_path__ + "img/logo.5137c1fa.svg";